import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import auth from './auth';
import { AppDispatch } from '../store';

const reducers = combineReducers({
  auth: persistReducer(
    {
      key: 'auth',
      storage,
    },
    auth,
  ),
});

export default reducers;

type RootState = ReturnType<typeof reducers>;

export const useTypedDispatch = useDispatch.withTypes<AppDispatch>();
export const useTypedSelector = useSelector.withTypes<RootState>();
